import { createSelector } from 'reselect'

const getAwsSettingsOptions: SelectOptionsSelector = (state) =>
  state.awsSettings.awsSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const awsSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getAwsSettingsOptions, (options) => options)
